var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dashed-link",attrs:{"href":_vm.href},on:{"click":function($event){$event.preventDefault();return _vm.setActiveTab($event)}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }